export const COUNTRY = {
  AR: 'AR',
  PY: 'PY',
  UY: 'UY'
}

export const ANALIYZE4 = 'ANALYZE:4'

export const EMPTY = ''

export const INITIALIZED = 'INITIALIZED'
export const ACCEPTED = 'ACCEPTED'
export const ENDED = 'ENDED'

export const CANCELLED = 'CANCELLED'

export const FLOW_ID = 'flowId'

export const OBD_RESULT_POSITIVE = 'POSITIVE'
export const OBD_RESULT_CANCELLED = 'CANCELLED'
export const OBD_RESULT_NEGATIVE = 'NEGATIVE'
export const OBD_RESULT_BLOCKED = 'BLOCKED'

export const URL: Record<string, string> = {
  activaciones: 'activaciones',
  portabilidades: 'portabilidades'
}

export const OPERATION_TYPE: any = {
  activaciones: 'KPS',
  portabilidades: 'PPK'
}

export const EVENTS = {
  saveActivation: 'SAVE_ACTIVATION_DOCUMENT',
  savePortability: 'SAVE_PORTABILITY_DOCUMENT',
  signActivation: 'SIGN_ACTIVATION_DOCUMENT',
  signPortability: 'SIGN_PORTABILITY_DOCUMENT',
  cancelDocument: 'CANCEL_DOCUMENT'
}
